import(/* webpackMode: "eager", webpackExports: ["HeroBanner"] */ "/app/components/frontend/common/hero-banner.tsx");
